<template>
  <div>
    <h1>Home Page</h1>

    <v-row>
      <v-col cols="12" xs="12" sm="6" md="7">

        <v-card width="100%">
          <v-card-title>Not Available Yet</v-card-title>
          <v-card-text>
            <p>
              This is the home page for the overall application.  There is nothing to see here yet because we aren't sure what this page will do yet.
              That being said, we left it here in order for app developers to understand that their app will be one of many apps available on the sidebar.
            </p>
            

          </v-card-text>
        </v-card>

     </v-col>
    </v-row>

    <v-row dense>
      <v-col >
        <!-- <start-end-date-control  
      :startDate.sync="dateValues.startDate"
      :endDate.sync="dateValues.endDate"
      :numIncSD.sync="dateValues.numIncSD"
      :numIncED.sync="dateValues.numIncED"
        ></start-end-date-control> -->
      </v-col>
</v-row>
<!-- {{JSON.stringify(dateValues)}} -->


<!-- <sample-detail 
  :s_Key.sync="sampleDetailValues.s_Key"
  :site.sync="sampleDetailValues.site"
></sample-detail> -->

  </div>
</template>

<script>
  import startEndDateControl from "../components/startEndDateControl";
  import uiView from "@/_mixins/ui-view-mixin"
  export default {
    name: 'SamplePage',
    mixins : [uiView],
    components: {
    startEndDateControl
  },
    created()
    {
    },
    props : {},
    watch : {},
    computed : {
    },
    data: () => ({
dateValues:
    {
      numIncSD: "-2",
      numIncED: "0",
      startDate: null,
      endDate: null,
    },
    sampleDetailValues:
    {
      s_Key: "2182145",
      site: "CXO",
    },
    }),
    methods : { }

  }
</script>
<style lang="scss">
</style>
